import { render, staticRenderFns } from "./AddFormPage.vue?vue&type=template&id=7af1f6a4"
import script from "./AddFormPage.vue?vue&type=script&lang=js"
export * from "./AddFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports